import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';

const ProductReimbursableLogo = ({ defaultLogo , alternativeLogo , variant ='default' , className ,  })=>{
    const { getLabel  } = useIntl();
    if (!defaultLogo && !alternativeLogo) {
        return null;
    }
    const logoUrl = variant === 'alternative' && alternativeLogo ? alternativeLogo : defaultLogo;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('reimbursable-logo', className),
        "data-t": `reimbursable-logo-${variant}`
    }, /*#__PURE__*/ React.createElement("img", {
        className: "reimbursable-logo__image",
        src: logoUrl,
        alt: getLabel('products.insuranceReimbursable')
    }));
};

export { ProductReimbursableLogo };
//# sourceMappingURL=ProductReimbursableLogo.js.map
